import { render, staticRenderFns } from "./TabAmended.vue?vue&type=template&id=34df0061&"
import script from "./TabAmended.vue?vue&type=script&lang=js&"
export * from "./TabAmended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports